<template>
  <div>Thumb Up</div>
</template>

<script>
export default {
  name: "QRcode"
};
</script>

<style scoped>

</style>
